import React, { useContext, useEffect, useState } from 'react';
import {
  CHeader,
  CHeaderNav,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle
} from '@coreui/react';
import { Link, useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { Context } from '../contexts/AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const [info, setInfo] = useState({});
  const { authState, handleLogout } = useContext(Context);

  const _handleLogout = () => {
    handleLogout();
    navigate('/');
  };

  useEffect(() => {
    fetch('/api/versao')
      .then((data) => data.json())
      .then((response) => {
        if (response) {
          setInfo(response);
        }
      })
      .catch((err) => {
        console.log(err);
        setInfo({ versao: '1.0.0' });
      });
  }, []);

  return authState?.user ? (
    <CHeader withSubheader className='shadow'>
      <Link className='navbar-brand mt-2 ml-4' to='/'>
        <CIcon name='cib-dailymotion' /> Director {info.versao}
      </Link>
      <CHeaderNav className='px-3 ml-auto'>
        <CDropdown inNav className='c-header-nav-items mx-2' direction='down'>
          <CDropdownToggle className='c-header-nav-link'>
            <div className='c-avatar'>
              <CIcon name='cil-user' />
            </div>
            <span>
              {authState.user.login ||
                authState.user.nome ||
                authState.user.usuario}
            </span>
          </CDropdownToggle>
          <CDropdownMenu id='pop-menu' className='pt-0' placement='bottom-end'>
            <CDropdownItem header tag='div' color='light'>
              <strong>Opções</strong>
            </CDropdownItem>
            {authState.user.id === 1 || authState.user.papel === 'ADM' ? (
              <CDropdownItem key={'acessos-settings'} to={'/configuracoes'}>
                <CIcon name={`cil-settings`} className='mfe-2' />
                <span>Configurações</span>
              </CDropdownItem>
            ) : (
              ''
            )}
            <CDropdownItem divider />
            <CDropdownItem onClick={_handleLogout}>
              <CIcon name='cil-account-logout' className='mfe-2' />
              <span>Sair</span>
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      </CHeaderNav>
    </CHeader>
  ) : (
    ''
  );
};

export default Header;
